import { CircularProgress, Box, styled } from '@mui/material';

type SVLoaderProps = {
  isFullScreen?: boolean;
  size?: number;
};

export default function SVLoader({ isFullScreen, size = 120 }: SVLoaderProps) {
  const LoaderContainer = styled(Box)(() => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: isFullScreen ? '100vh' : 'auto',
  }));

  return (
    <LoaderContainer>
      <CircularProgress
        aria-label="Loading..."
        variant="indeterminate"
        disableShrink
        size={size}
        sx={{ color: 'primary' }}
      />
    </LoaderContainer>
  );
}
